import { Button, Popconfirm, Space, Switch, Table, Tag } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { useFormContext } from "react-hook-form";

import { useProductGroups } from "../hooks";
import {
  setModalProductGroups,
  setIsUpdateProductGroup,
  setProductGroupForUpdate,
} from "../../../redux/actions";
import { ProductGroup } from "../../../redux/@types";

export const TableProductGroups = () => {
  const dispatch = useDispatch();
  const { productGroups, isLoading, deleteProductGroup } = useProductGroups();

  const handleEdit = (record: ProductGroup) => {
    dispatch(setProductGroupForUpdate(record));
    dispatch(setIsUpdateProductGroup(true));
    dispatch(setModalProductGroups(true));
  };

  const handleDelete = (id: number) => {
    deleteProductGroup(id);
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 80,
    },
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Descripción",
      dataIndex: "description",
      key: "description",
      render: (description: string) => description || "-",
    },
    {
      title: "Estado",
      dataIndex: "active",
      key: "active",
      width: 100,
      render: (active: boolean) => (
        <Tag color={active ? "green" : "red"}>
          {active ? "Activo" : "Inactivo"}
        </Tag>
      ),
    },
    {
      title: "Productos",
      dataIndex: "products",
      key: "products",
      width: 100,
      render: (products: any[]) => (
        <Tag color="blue">{products?.length || 0}</Tag>
      ),
    },
    {
      title: "Acciones",
      key: "actions",
      width: 120,
      render: (_: any, record: ProductGroup) => (
        <Space size="small">
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
          />
          <Popconfirm
            title="¿Estás seguro de eliminar este grupo?"
            onConfirm={() => record.id && handleDelete(record.id)}
            okText="Sí"
            cancelText="No"
          >
            <Button type="text" danger icon={<DeleteOutlined />} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={productGroups}
      loading={isLoading}
      rowKey="id"
      pagination={{
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
      }}
    />
  );
};
